import { mapValues, pick, trim } from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'tss-react/mui';
import TextInput from '../ReusableComponents/TextInput/TextInput';

const useStyles = makeStyles()(() => ({
  row: {
    alignItems: 'center',
    display: 'flex',
  },
}));

export default function UserNamesFields(props) {
  const { classes } = useStyles();
  const [form, setForm] = useState(
    pick(props.form, ['first_name', 'last_name', 'vendor_name']),
  );
  const [errors, setErrors] = useState(mapValues(form, () => false));

  const onChange = (e) => {
    const { name, value } = e.target;
    if (!value) {
      props.onErrorUpdate(name, 'error');
      setErrors((err) => ({ ...err, [name]: true }));
    } else {
      props.onErrorUpdate(name, null);
      setErrors((err) => ({ ...err, [name]: false }));
    }
    setForm((f) => ({ ...f, [name]: value }));
    props.onChange(name, trim(value));
  };

  return (
    <div className={classes.row}>
      <TextInput
        fullWidth
        required
        error={errors.first_name}
        label="First Name"
        variant="outlined"
        onChange={onChange}
        name="first_name"
        value={form.first_name || ''}
        id="user-info-first-name"
        autoComplete="no"
        disabled={props.disabled}
      />
      <TextInput
        fullWidth
        required
        error={errors.last_name}
        label="Last Name"
        variant="outlined"
        onChange={onChange}
        name="last_name"
        value={form.last_name || ''}
        id="user-info-last-name"
        autoComplete="no"
        disabled={props.disabled}
      />
      <TextInput
        fullWidth
        required
        error={errors.vendor_name}
        label="Company Name"
        variant="outlined"
        onChange={onChange}
        name="vendor_name"
        value={form.vendor_name || ''}
        id="user-info-vendor_name"
        autoComplete="no"
        disabled={props.disabled}
      />
    </div>
  );
}

UserNamesFields.propTypes = {
  form: PropTypes.shape({}).isRequired,
  onErrorUpdate: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
